import { IAddress, IClient } from "@utils/interfaces";

/**
 * Regra 2: O primeiro endereço da lista é o padrão.
 */
export function getDefaultAddress(customer: IClient): IAddress | null {
  return customer.address?.[0] ?? null;
}

/**
 * Regra 12: Cliente com hiddePrice === false não deve exibir preços.
 */
export function shouldShowPrices(customer: IClient | null): boolean {
  return customer?.hiddePrice !== false;
}
